import React from "react";

const CloseX = React.memo(({ styles = {}, variations = {}, fill = "#D64949" }) => {
	return (
		<svg
			width="14"
			height="14"
			viewBox="0 0 14 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			style={{ ...styles }}
			{...variations}
		>
			<path
				d="M2.11558 1.01854L1.9388 0.841759L1.76203 1.01854L0.819317 1.96124L0.64254 2.13802L0.819317 2.3148L5.50452 7L0.819317 11.6852L0.64254 11.862L0.819317 12.0388L1.76203 12.9815L1.9388 13.1582L2.11558 12.9815L6.80078 8.29626L11.486 12.9815L11.6628 13.1582L11.8395 12.9815L12.7822 12.0388L12.959 11.862L12.7822 11.6852L8.09704 7L12.7822 2.3148L12.959 2.13802L12.7822 1.96124L11.8395 1.01854L11.6628 0.841759L11.486 1.01854L6.80078 5.70374L2.11558 1.01854Z"
				fill={fill}
				stroke="#D64949"
				stroke-width="0.5"
			/>
		</svg>
	);
});

export default CloseX;
